import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Radar, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

/** Dashboard tile — surveillance inspections due across all cases. */
export function SurveillanceSummaryCard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get("/cases/surveillance-overview").then((r) => { if (alive) setData(r?.data?.data || null); }).catch(() => { if (alive) setData({ summary: {}, rows: [] }); });
    return () => { alive = false; };
  }, []);
  if (!data) return null;
  const s = data.summary || {};
  const next = (data.rows || []).filter((r) => ["OVERDUE", "DUE_SOON"].includes(r.bucket)).slice(0, 4);
  return (
    <div className="co-card p-5" data-testid="surveillance-summary-card">
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="font-bold text-slate-900 flex items-center gap-2"><Radar className="w-4 h-4 text-cyan-700" />Surveillance inspections</div>
          <div className="text-xs text-slate-500">Across all certified cases</div>
        </div>
        <Link to="/surveillance" className="text-xs font-semibold text-cyan-800 hover:underline inline-flex items-center gap-1" data-testid="surveillance-summary-link">Open <ArrowRight className="w-3 h-3" /></Link>
      </div>
      <div className="grid grid-cols-3 gap-2 mb-3">
        {[["Overdue", s.OVERDUE, "text-red-700"], ["Due ≤30d", s.DUE_SOON, "text-amber-700"], ["Upcoming", s.UPCOMING, "text-cyan-700"]].map(([l, v, t]) => (
          <div key={l} className="rounded-lg bg-slate-50 px-3 py-2">
            <div className="text-[10px] uppercase tracking-widest text-slate-500 font-bold">{l}</div>
            <div className={`text-xl font-bold ${t}`} style={{ fontFamily: "Plus Jakarta Sans" }}>{v ?? 0}</div>
          </div>
        ))}
      </div>
      {next.length ? (
        <ul className="divide-y divide-slate-100 text-sm">
          {next.map((r) => (
            <li key={r.surveillance_id} className="flex items-center gap-2 py-1.5">
              <Link to={`/cases/${r.case_id}?surveillance_id=${r.surveillance_id}`} className="font-mono text-xs text-cyan-800 hover:underline">{r.case_number}</Link>
              <span className="flex-1 truncate text-slate-700">{r.name}</span>
              <span className={`text-[11px] ${r.bucket === "OVERDUE" ? "text-red-600" : "text-slate-500"}`}>{r.due_date}</span>
              {!r.follow_up_case_id && r.reminder_started ? <span className="text-[10px] font-bold uppercase text-amber-700 bg-amber-50 rounded px-1.5 py-px">open case</span> : null}
            </li>
          ))}
        </ul>
      ) : <div className="text-xs text-slate-400">{s.awaiting_follow_up ? "" : "Nothing due in the next 30 days."}</div>}
      {s.awaiting_follow_up ? <div className="mt-2 text-[11px] text-amber-700 font-semibold" data-testid="surveillance-summary-awaiting">{s.awaiting_follow_up} inspection(s) awaiting a follow-up case</div> : null}
    </div>
  );
}
